// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2oj5S","empty":"ModalGraph_empty__18akB"};